export default __webpack_public_path__ + "static/media/product10.4326a5d7.jpg";